// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://arbiscan.io/address/0x7dfF72693f6A4149b17e7C6314655f6A9F7c8B33
export const GHO_TOKEN = '0x7dfF72693f6A4149b17e7C6314655f6A9F7c8B33';

// https://arbiscan.io/address/0xB94Ab28c6869466a46a42abA834ca2B3cECCA5eB
export const GHO_CCIP_TOKEN_POOL = '0xB94Ab28c6869466a46a42abA834ca2B3cECCA5eB';

// https://arbiscan.io/address/0xd2D586f849620ef042FE3aF52eAa10e9b78bf7De
export const GHO_AAVE_CORE_STEWARD = '0xd2D586f849620ef042FE3aF52eAa10e9b78bf7De';

// https://arbiscan.io/address/0xa9afaE6A53E90f9E4CE0717162DF5Bc3d9aBe7B2
export const GHO_BUCKET_STEWARD = '0xa9afaE6A53E90f9E4CE0717162DF5Bc3d9aBe7B2';

// https://arbiscan.io/address/0xCd5ab470AaC5c13e1063ee700503f3346b7C90Db
export const GHO_CCIP_STEWARD = '0xCd5ab470AaC5c13e1063ee700503f3346b7C90Db';

// https://arbiscan.io/address/0x8513e6F37dBc52De87b166980Fa3F50639694B60
export const RISK_COUNCIL = '0x8513e6F37dBc52De87b166980Fa3F50639694B60';

export const CHAIN_ID = 42161;
